import { NgClass, NgIf } from '@angular/common';
import {
  ChangeDetectionStrategy,
  Component,
  HostListener,
  ViewChild,
} from '@angular/core';
import { RouterLink, RouterLinkActive } from '@angular/router';

import { MatButtonModule } from '@angular/material/button';

import { PermissionsService } from '@eai-tdv/core/services/permissions';

import { IconComponent } from '@eai-tdv/shared/icon';
import { TooltipDirective } from '@eai-tdv/shared/tooltip';

import { AvatarComponent } from '../../../shared/components/avatar/avatar.component';
import { LogoComponent } from '../../../shared/components/logo/logo.component';
import { AppMenuService } from '../../services';
import { AuthUserStateService } from '../../services/auth-user-state.service';
import { NavigationWebService } from '../../services/navigation.service';
import { ROUTE_NAMES_W } from '../../services/routes';
import { ProfileTootilpComponent } from './profile-tooltip/profile-tooltip.component';

@Component({
  imports: [
    IconComponent,
    AvatarComponent,
    TooltipDirective,
    NgClass,
    NgIf,
    ProfileTootilpComponent,
    RouterLink,
    RouterLinkActive,
    LogoComponent,
    MatButtonModule,
  ],
  selector: 'tdv-app-menu',
  templateUrl: './app-menu.component.html',
  styleUrls: ['./app-menu.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AppMenuComponent {
  public readonly ROUTE_NAMES = ROUTE_NAMES_W;
  public PATIENTS_ROUTE = NavigationWebService.getPatientListSegments();
  public isOpen = false;

  @HostListener('mouseenter') public onMouseEnter(): void {
    this.appMenuS.toggleHoverState(true);
  }

  @HostListener('mouseleave') public onMouseLeave(): void {
    this.appMenuS.toggleHoverState(false);
  }

  @ViewChild(TooltipDirective) tooltipDirective?: TooltipDirective;
  constructor(
    public readonly authUserStateS: AuthUserStateService,
    private readonly appMenuS: AppMenuService,
    public readonly permissionsS: PermissionsService,
  ) {}

  public onMenuToggled(isOpen: boolean): void {
    this.isOpen = isOpen;
  }

  public onCloseTooltip(): void {
    this.tooltipDirective?.closeTooltip();
  }
}
